import React from 'react';
import { userDisplayName, STATUS_LABELS, STATUS_BADGE_CLASS, taskCode, formatDate, isOverdue } from './helpers';

function TaskListView({ tasks, users, onOpenTask, commentCounts = {}, attachmentCounts = {} }) {
  if (tasks.length === 0) {
    return <div className="empty-state">Aucune tâche pour ce projet.</div>;
  }

  return (
    <div className="table-container">
      <table>
        <thead>
          <tr>
            <th>Réf.</th>
            <th>Tâche</th>
            <th>Responsable</th>
            <th>Statut</th>
            <th>Échéance</th>
            <th>Avancement</th>
            <th>Commentaires</th>
            <th>Documents</th>
          </tr>
        </thead>
        <tbody>
          {tasks.map((task) => (
            <tr key={task.id} className="clickable" onClick={() => onOpenTask(task)}>
              <td>{taskCode(task.id)}</td>
              <td>{task.name}</td>
              <td>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <div className="avatar">{userDisplayName(users.find((u) => u.id === task.assigned_to)).substring(0, 2).toUpperCase()}</div>
                  <div>
                    {userDisplayName(users.find((u) => u.id === task.assigned_to))}
                    {task.delegated_to && (
                      <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>
                        déléguée à {userDisplayName(users.find((u) => u.id === task.delegated_to))}
                      </div>
                    )}
                  </div>
                </div>
              </td>
              <td>
                <span className={`badge ${STATUS_BADGE_CLASS[task.status] || 'badge-todo'}`}>
                  {STATUS_LABELS[task.status] || task.status}
                </span>
              </td>
              <td><span className={isOverdue(task) ? 'date-retard' : ''}>{formatDate(task.due_date)}</span></td>
              <td style={{ width: 140 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <div className="progress-bar" style={{ flex: 1, margin: 0 }}>
                    <div className="progress-fill" style={{ width: `${task.progress_percent || 0}%` }} />
                  </div>
                  <span style={{ fontSize: 11.5, color: 'var(--text-muted)' }}>{task.progress_percent || 0}%</span>
                </div>
              </td>
              <td>💬 {commentCounts[task.id] || 0}</td>
              <td>📎 {attachmentCounts[task.id] || 0}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default TaskListView;
